import { useDeviceStore } from '@/stores'
import { getImageUrl } from '@/utils/assets'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

export function useDeviceImage() {
  const deviceStore = useDeviceStore()
  const { currentDevice } = storeToRefs(deviceStore)
  const currentDeviceColor = computed(() => {
    if (!currentDevice.value?.manifest?.ui.colors) return

    const { series, current } = currentDevice.value?.manifest?.ui.colors
    if (!series.length) return

    return series.find((color) => color.key === current)
  })

  const deviceThumbImage = computed(() => {
    const ui = currentDevice.value?.manifest?.ui
    const color = currentDeviceColor.value
    if (!ui?.assetsDir || !color?.key) return ''
    return getImageUrl(`${ui.assetsDir}/thumb_${color.key}.png`)
  })

  return {
    deviceThumbImage,
  }
}
